import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=5ce53ae5&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=ts"
export * from "./ShopDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=5ce53ae5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce53ae5",
  null
  
)

export default component.exports